<div class="flex flex-col">
	<ng-container *ngFor="let timeline of timelines; last as last">
		<ng-container *ngIf="!timeline?.disabled">
		<ng-container [ngSwitch]="timeline?.state">
			<ng-container *ngSwitchDefault>
				<ng-container  *ngTemplateOutlet="inactiveStepper; context:{obj:{step:timeline?.step, title: timeline?.title, opacity: timeline?.isFinalStep || last ? 0 : 1}}"></ng-container>
			</ng-container>
			<ng-container *ngSwitchCase="TimelineStatus.active">
				<ng-container *ngTemplateOutlet="activeStepper; context:{obj:{step:timeline?.step, title: timeline?.title, opacity: timeline?.isFinalStep || last ? 0 : 1}}"></ng-container>
			</ng-container>
			<ng-container *ngSwitchCase="TimelineStatus.completed">
				<ng-container *ngTemplateOutlet="completedStepper; context:{obj:{step:timeline?.step, title: timeline?.title, opacity: timeline?.isFinalStep || last ? 0 : 1}}"></ng-container>
			</ng-container>
		</ng-container>
		</ng-container>
	</ng-container>
</div>



<ng-template #completedStepper let-obj='obj'>
	<div class="flex gap-[9px]">
		<div>
			<svg width="27" height="72" viewBox="0 0 27 72" fill="none" xmlns="http://www.w3.org/2000/svg">
				<circle cx="13.4301" cy="13.4301" r="13.4301" fill="#BCE8C0"/>
				<circle cx="13.4301" cy="13.4301" r="10.6366" fill="#1EB12D"/>
				<circle cx="13.4299" cy="13.4301" r="8.27291" fill="#18902C"/>
				<path d="M9.40263 13.4033C9.69091 13.1236 10.158 13.1231 10.4466 13.4023L11.6708 14.5862C11.7651 14.6775 11.9179 14.6774 12.0122 14.5859L16.1946 10.5251C16.4847 10.2435 16.9552 10.2443 17.2442 10.5269C17.5316 10.8081 17.5308 11.262 17.2422 11.5422L12.6406 16.0098C12.1993 16.4382 11.4839 16.4382 11.0425 16.0098L9.40263 14.4177C9.11416 14.1376 9.11416 13.6834 9.40263 13.4033Z" fill="white"/>
				<rect [attr.opacity]="obj?.opacity" x="11.7847" y="26.8599" width="3.29098" height="44.7668" fill="#1EB12D"/>
			</svg>
		</div>
		<div class="flex flex-col gap-[4px]">
			<div class="text-[10px] leading-[14px] font-medium text-[#666]">
				STEP {{obj?.step}}
			</div>
			<div class="text-[14px] leading-[19.6px] font-semibold text-black">
				{{obj?.title}}
			</div>
		</div>
	</div>
</ng-template>
<ng-template #activeStepper let-obj='obj'>
<div>
	<div class="flex gap-[9px]">
		<div>
			<svg width="27" height="72" viewBox="0 0 27 72" fill="none" xmlns="http://www.w3.org/2000/svg">
				<circle cx="13.4301" cy="13.4301" r="13.4301" fill="#0361F0"/>
				<circle cx="13.43" cy="13.4301" r="10.6366" fill="white"/>
				<circle cx="13.43" cy="13.4301" r="8.27291" fill="#B3CDFA"/>
				<rect x="11.7846" [attr.opacity]="obj?.opacity" y="26.8599" width="3.29098" height="44.7668" fill="#CED6E3"/>
			</svg>
		</div>
		<div class="flex flex-col gap-[4px]">
			<div class="text-[10px] leading-[14px] font-medium text-[#666]">
				STEP {{obj?.step}}
			</div>
			<div class="text-[14px] leading-[19.6px] font-semibold text-black">
				{{obj?.title}}
			</div>
		</div>
	</div>
</div>
</ng-template>
<ng-template #inactiveStepper let-obj='obj'>
<div class="flex gap-[9px]">
	<div>
		<svg width="27" height="72" viewBox="0 0 27 72" fill="none" xmlns="http://www.w3.org/2000/svg">
			<circle cx="13.4301" cy="13.4301" r="13.4301" fill="#CED6E3"/>
			<circle cx="13.43" cy="13.4301" r="10.6366" fill="white"/>
			<circle cx="13.43" cy="13.4301" r="8.27291" fill="#E7EAF1"/>
			<rect x="11.7846" y="26.8599" [attr.opacity]="obj?.opacity" width="3.29098" height="44.7668" fill="#CED6E3"/>
		</svg>
	</div>
	<div class="flex flex-col gap-[4px]">
		<div class="text-[10px] leading-[14px] font-medium text-[#666]">
			STEP {{obj?.step}}
		</div>
		<div class="text-[14px] leading-[19.6px] font-semibold text-black">
			{{obj?.title}}
		</div>
	</div>
</div>
</ng-template>
